import type { QueryClient } from '@tanstack/react-query';

export const MONTHLY_BATCHES_QUERY_KEY = 'monthly-batches' as const;
export const MONTHLY_BATCH_SELECTOR_OPTIONS_QUERY_KEY = [
  MONTHLY_BATCHES_QUERY_KEY,
  'selector-options',
] as const;

export const invalidateMonthlyBatchQueries = (queryClient: QueryClient) => {
  void queryClient.invalidateQueries({ queryKey: [MONTHLY_BATCHES_QUERY_KEY] });
};
